import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAPI } from '@/hooks/useAPI'
import { getStudios } from '@/services/api/studios'
import StudioHeroBanner from './StudioHeroBanner'
import StudiosGrid from './StudiosGrid'

const StudiosPage = () => {
  const { t, i18n } = useTranslation()
  const { data: studios, loading, error } = useAPI(() => getStudios(), [i18n.language])

  return (
    <div className="min-h-screen bg-white">
      
      <StudioHeroBanner />
      
      <StudiosGrid 
        studios={studios}
        loading={loading}
        error={error}
      />
    </div>
  )
}

export default StudiosPage 